import { render, staticRenderFns } from "./Rune.vue?vue&type=template&id=671d084a"
import script from "./Rune.vue?vue&type=script&lang=js"
export * from "./Rune.vue?vue&type=script&lang=js"
import style0 from "./Rune.vue?vue&type=style&index=0&id=671d084a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports